(function () {
  var SECTION_SELECTOR = '.oddit-section-the-difference';
  var VIDEO_SELECTOR = '.oddit-section-the-difference__media-video';

  function attemptPlay(video) {
    video.muted = true;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function initSection(section) {
    var video = section.querySelector(VIDEO_SELECTOR);
    if (!video) return;

    attemptPlay(video);
    video.addEventListener('canplay', function () { attemptPlay(video); }, { once: true });
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
